import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { uniqueIdentificationGenerator } from '../../utils/uniqueIdentificationGenerator'

import searchIcon from 'images/search-icon.svg'

import errorIcon from 'images/error-icon.svg'

class SearchInput extends Component {
  static propTypes = {
    /* The input placeholder */
    placeholder: PropTypes.string,

    /* The text that will be displayed along with the input */
    label: PropTypes.string,

    /* The input name */
    name: PropTypes.string,

    /* The input id */
    id: PropTypes.string,

    /* Initial value */
    value: PropTypes.string,

    /* Callback for when the input search is triggered */
    onSearch: PropTypes.number,

    /* Callback for when the input search is cleaned */
    onClear: PropTypes.number,

    /* Callback for when the input changes */
    onChange: PropTypes.number,

    /* Determine if the input is or not disabled */
    disabled: PropTypes.bool,

    /* Determine if the input is or not readonly */
    readOnly: PropTypes.bool,
  }

  state = {
    /* The input value */
    value: this.props.value || '',

    /* Stores the information of wheter the input is or not on focus */
    isOnFocus: false,
  }

  enterPressed = this.enterPressed.bind(this)

  enterPressed(event) {
    const code = event.keyCode || event.which
    if (code === 13) this.onSearch()
  }

  onChange(e) {
    const { onChange = () => {} } = this.props
    this.setState({ value: e.target.value })
    onChange(e)
  }

  onSearch() {
    const { onSearch = () => {} } = this.props
    onSearch()
  }

  onClear() {
    const { onClear = () => {}, onChange = () => {} } = this.props
    this.setState({ value: '' }, onClear)
    onChange({ target: { value: '' } })
  }

  render() {
    const { label, name, disabled, id, placeholder } = this.props
    const { value, isOnFocus } = this.state

    const customId = id || uniqueIdentificationGenerator('input-text_')
    const customName = name || uniqueIdentificationGenerator('input-text_')
    return (
      <>
        <div
          className={`input-search-container ${disabled ? 'disabled' : ''} ${
            isOnFocus === true ? 'focus' : ''
          }`}
        >
          <label>{label}</label>
          <div className='input-search'>
            <span className='search-button' onClick={() => this.onSearch()}>
              <img src={searchIcon} />
            </span>
            <input
              id={customId}
              name={customName}
              disabled={disabled}
              onChange={(e) => this.onChange(e)}
              onFocus={() => this.setState({ isOnFocus: true })}
              onBlur={() => this.setState({ isOnFocus: false })}
              onKeyPress={this.enterPressed}
              value={value}
              placeholder={placeholder}
            />
            <span className='clear-button'>
              {value && <img src={errorIcon} onClick={() => this.onClear()} />}
            </span>
          </div>
        </div>
      </>
    )
  }
}

export default SearchInput
